import React from 'react';
import TopUpDashboardPage from '../../../../../topup-src/components/pages/SPAContainer/pages/DashboardPage';
import {
    StyledContainerWrapper,
    StyledContainer,
    StyledMenuContainer,
    NavigatorContainer,
    StyledWrapper
} from './styles';
import { Stepper } from '../../../../atoms';
import { useHistory, useLocation } from 'react-router-dom';
import { ReduxState } from '../../../../../redux';
import { useDispatch, useSelector } from 'react-redux';
import { EnrolmentNavigator } from '../../../../containers';
import { INTERNAL_ROUTES } from '../../../../../utils/constants';
import { setCurrentStepperStep, setIsSuperTopUpSelected } from '../../../../../redux/slices/ApplicationStateSlice';
import { fetchUserPolicyList } from '../../../../../topup-src/redux/slices/PolicyListSlice';
import { enrolUserPolicyFamily } from '../../../../../redux/slices/EnrolmentSlice/thunks';
import { checkIfTopUpAvailable } from '../../../../../utils/common';
import { FreshChat } from '../../../../atoms/FreshChat';
import { LocationState } from '../../../../../topup-src/utils/types';
import { fetchParentalPolicyData } from '../../../../../topup-src/redux/slices/PolicyListSlice/thunks';
import { checkParentalPolicy, checkTopUpAvailable } from '../../../../../utils/PolicyServices';

const SuperTopUpPage: React.FunctionComponent = () => {
    const location = useLocation<LocationState>();
    const selectedMemberTopUp = useSelector((state: ReduxState) => state.enrolment.selectedMemberTopUp);
    const currentSelectedStep = useSelector((state: ReduxState) => state.applicationState.currentStepperStep);
    const userId = useSelector((state: ReduxState) => state.user.userData.data?.userId || '');
    const topUpDetails: any = useSelector((state: ReduxState) => state.TopUp_policyData.memberTopUp);
    const history = useHistory();
    const dispatch = useDispatch();
    const checkSuperTopUpAvailable = checkTopUpAvailable();
    const currentlySelectedPolicy = useSelector((state: ReduxState) => state.enrolment.currentlySelectedPolicy);
    const superTopUpAvailable = checkIfTopUpAvailable(checkSuperTopUpAvailable, currentlySelectedPolicy);
    const policyId = useSelector((state: ReduxState) => state.TopUp_applicationState.topupPolicyId);
    React.useEffect(() => {
        dispatch(setCurrentStepperStep({ currentStepperStep: 2 }));
        if (currentlySelectedPolicy && checkParentalPolicy(currentlySelectedPolicy)) {
            const parentalPolicyId = currentlySelectedPolicy?.policyId ?? '';
            dispatch(fetchParentalPolicyData({ userId, parentalPolicyId }));
        } else {
            dispatch(fetchUserPolicyList({ userId }));
        }
    }, [userId]);
    const showSummary = (isTopUpSelected: boolean) => {
        dispatch(setCurrentStepperStep({ currentStepperStep: currentSelectedStep + 1 }));
        if (isTopUpSelected) {
            if (topUpDetails.hasOwnProperty('annualPremium')) {
                const dependentsArray = topUpDetails?.userIds.filter((item: string) => item !== userId);
                dispatch(
                    enrolUserPolicyFamily({
                        userId: userId,
                        policyId: policyId,
                        slabId: topUpDetails.slabId,
                        enrolmentStatus: 'PENDING',
                        policyStatus: 'PENDING',
                        dependentIds: dependentsArray,
                        parentalPolicyId:
                            currentlySelectedPolicy && checkParentalPolicy(currentlySelectedPolicy)
                                ? currentlySelectedPolicy.policyId
                                : ''
                    })
                );
                history.push(INTERNAL_ROUTES.summary, { previousUrl: location.pathname });
            }
            if (superTopUpAvailable) {
                dispatch(setIsSuperTopUpSelected({ isSuperTopupSelected: true }));
            }
        } else {
            dispatch(setIsSuperTopUpSelected({ isSuperTopupSelected: false }));
            history.push(INTERNAL_ROUTES.summary, { previousUrl: location.pathname });
        }
    };
    return (
        <StyledContainerWrapper>
            <FreshChat />
            <StyledMenuContainer>
                <Stepper />
            </StyledMenuContainer>
            <StyledWrapper>
                <StyledContainer>
                    <TopUpDashboardPage />
                </StyledContainer>
            </StyledWrapper>

            <NavigatorContainer>
                <EnrolmentNavigator
                    loading={topUpDetails.hasOwnProperty('annualPremium') ? false : true}
                    isEnrolMemberValid={true}
                    showSummary={showSummary}
                    memberTopUp={selectedMemberTopUp}
                    currentStep={currentSelectedStep}
                    nomineeConsumedPercentage={100}
                />
            </NavigatorContainer>
        </StyledContainerWrapper>
    );
};

export default SuperTopUpPage;
